import { Button, makeStyles, mergeClasses, tokens } from '@fluentui/react-components';
import React, { MouseEventHandler, ReactNode } from 'react';
import { customPalette } from '../../theme';
export interface IIconTabButtonProps {
    buttonKey: string;
    buttonId?: string;
    label: string;
    ariaLabel?: string;
    icon?: ReactNode;
    activeIcon?: ReactNode;
    onButtonClick?: MouseEventHandler<HTMLButtonElement>;
    isActive?: boolean;
    disabled?: boolean;
    url?: string;
    role?: string;
}

const useStyles = makeStyles({
    button: {
        height: '44px',
        backgroundColor: tokens.colorNeutralBackground1,
        borderRadius: '0',
        padding: '0 10px',
        margin: '0 5px',
        borderBottom: '3px solid transparent',
        ':hover': {
            backgroundColor: tokens.colorNeutralBackground1,
        },
    },
    // rgb(50, 49, 48) — applied only when not disabled so Fluent disabled styles win
    enabled: {
        color: customPalette.blueDark,
        ':hover': {
            color: customPalette.blueDark,
        },
    },
    inactive: {
        ':hover': {
            borderBottomColor: tokens.colorNeutralStroke1Hover,
            color: customPalette.blueDark,
            '> .fui-Button__icon': {
                color: customPalette.blueDark,
            },
        },
    },
    active: {
        borderBottomColor: tokens.colorBrandStroke1,
        ':hover': {
            borderBottomColor: tokens.colorBrandStroke1,
            '> .fui-Button__icon': {
                color: tokens.colorBrandStroke1,
            },
        },
        // rgb(0, 59, 92) — filled icon matches active underline
        '> .fui-Button__icon': {
            color: tokens.colorBrandStroke1,
        },
    },
});

const IconTabButton: React.FC<IIconTabButtonProps> = ({
    buttonKey,
    buttonId,
    label,
    ariaLabel,
    icon,
    activeIcon,
    onButtonClick,
    isActive,
    disabled,
    url,
    role,
}) => {
    const styles = useStyles();

    return (
        <Button
            key={buttonKey}
            id={buttonId}
            icon={isActive ? activeIcon ?? icon : icon}
            onClick={onButtonClick}
            aria-label={ariaLabel ?? label}
            disabled={disabled}
            disabledFocusable={disabled}
            appearance='subtle'
            className={mergeClasses(styles.button, !disabled && styles.enabled, !disabled && (isActive ? styles.active : styles.inactive))}
            href={url}
            target={url ? '_blank' : undefined}
            role={role}
        >
            {label}
        </Button>
    );
};

export default IconTabButton;
